export default __webpack_public_path__ + "static/media/storageUnit1-afterD-768w.c93c73a8.avif";